import { init } from './init'
import { claim } from './claim'
import { list } from './list'
import { updateStatus } from './updateStatus'
import { post } from './post'

export const mutations = Object.assign({}, init, claim, list, updateStatus, post)
